import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { createTheme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import './App.css';
import './i18n';
import store from './store';
import Alerts from './components/Alerts';
import DatePickerProvider from './components/DatePickerProvider';
import { QueryClient, QueryClientProvider } from 'react-query';

import { RenderRoutes , routes } from './routes/routes';

function App() {
  const primaryColor = '#99B64E';

  const themeOptions = {
    palette: {
      primary: {
        main: primaryColor,
        contrastText: '#fff'
      },
      secondary: {
        main: '#76C9E6',
        contrastText: '#fff'
      },
      tertiary: {
        main: grey
      },
      text: {
        primary: '#252733',
        secondary: '#000000'
      }
    },
    overrides: {
      MuiDialogTitle: {
        root: {
          backgroundColor: primaryColor
        }
      },
      MuiLink: {
        underlineHover: {
          cursor: 'pointer'
        }
      }
    }
  };

  const theme = createTheme(themeOptions);

  return (
    <Suspense fallback={ <>Loading...</> }>
      <Provider store={ store }>
        <MuiThemeProvider theme={ theme }>
          <DatePickerProvider>
            <QueryClientProvider
              client={
                new QueryClient({
                  defaultOptions: {
                    queries: {
                      retry: false,
                      refetchOnWindowFocus: false
                    }
                  }
                })
              }
            >
              <RenderRoutes routes={ routes } />
            </QueryClientProvider>
          </DatePickerProvider>
          <Alerts/>
        </MuiThemeProvider>
      </Provider>
    </Suspense>
  );
}

export default App;
